<template>
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card v-if="course">
            <v-toolbar flat color="#008dd4" dark>
                <v-btn icon @click="$parent.links_dialog = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>Enlaces del curso {{ course.name }}</v-toolbar-title>
            </v-toolbar>

            <v-card-text>
                <v-container>
                    <v-row justify="center" align-center>
                        <v-col cols="12" xl="4" lg="4" md="12">
                            <template v-for="(link, index) in links">
                                <v-list-item :key="index" two-line>
                                    <v-list-item-icon>
                                        <v-icon color="#008dd4">mdi-link</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title v-text="link.date"></v-list-item-title>
                                        <v-list-item-subtitle>
                                            Alumnos en clase : {{ link.assistance.length }}
                                        </v-list-item-subtitle>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <v-tooltip right>
                                            <template v-slot:activator="{ attrs, on }">    
                                                <v-btn v-bind="attrs" v-on="on" icon @click="copy(link.meet_url)">
                                                    <v-icon>mdi-content-copy</v-icon>
                                                </v-btn>
                                            </template> 
                                            <span>Copiar enlace</span>   
                                        </v-tooltip>
                                    </v-list-item-action>
                                </v-list-item>
                                <v-divider :key="'D-'+index"></v-divider>
                            </template>
                        </v-col>
                    </v-row>
                </v-container>

            </v-card-text>
        </v-card>
    </v-dialog>
</template>
<script>

import iziToast from 'izitoast'

export default {
    props:['dialog', 'course'],
    data:() => ({
        links:"",
    }),

    watch:{
        course:function()
        {
            this.get_links(this.course.id)
        }
    },

    methods:{
        get_links:function(id)
        {
            axios.get('/lessons', { params:{ course_id:id } }).then(response => {
                if(response.data.items.length > 0){
                    this.links = response.data.items
                }else{
                    this.$parent.links_dialog = false
                    iziToast.error({
                        title:"Error",
                        message:"El curso no tiene enlaces registrados",
                        position:"topRight"
                    })
                }
            })
        },

        copy: async function(link)
        {
            await navigator.clipboard.writeText(link);
            iziToast.success({
                title:"Correcto",
                position:'topRight',
                message: "Enlace copiado correctamente"
            })
        },
    }
    
}
</script>